import { createReducer as reduxCreateReducer } from 'redux-create-reducer'

export default function createReducer(actions) {
  const initialState = {
    userData: {},
    loginData: {},
    user: {},
    token: '',
    impersonatedUser: {},
    passwordResetSuccessful: false,
    profileChangeInProgress: false,
  }

  const setLoginData = createSetter('loginData')

  return reduxCreateReducer(initialState, {
    [actions.AUTH_SET_USER_DATA]: createSetter('userData'),
    [actions.AUTH_LOGIN_SUCCESS]: setLoginData,
    [actions.AUTH_USER_SUCCESS]: (state, { user }) => ({
      ...state,
      user: {
        ...user,
        profiles: user.profiles.slice().sort((a, b) => {
          const x = a.organizationName.toLowerCase()
          const y = b.organizationName.toLowerCase()
          return x < y ? -1 : x > y ? 1 : 0
        }),
      },
    }),
    [actions.AUTH_INVALIDATE]: () => initialState,
    [actions.AUTH_SET_IMPERSONATED_USER]: createSetter('impersonatedUser'),
    [actions.AUTH_SET_PASSWORD_RESET_SUCCESSFUL]: createSetter(
      'passwordResetSuccessful'
    ),
    [actions.AUTH_SET_PROFILE_CHANGE_IN_PROGRESS]: createSetter(
      'profileChangeInProgress'
    ),
  })
}

function createSetter(key) {
  return (state, action) => ({
    ...state,
    [key]: action[key],
  })
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/lib/auth/reducer.js